var map = {
	"./0iconmonstr-paintbrush-7.svg": 4489,
	"./1kbluPal.png": 1729,
	"./2kredPal.png": 9511,
	"./3kgreenPal.png": 3193,
	"./4kgoldPal.png": 3632,
	"./5kgrayPal.png": 7937
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3573;